import { render, staticRenderFns } from "./FavoriteLocationInfo.vue?vue&type=template&id=21353ae4&"
import script from "./FavoriteLocationInfo.vue?vue&type=script&lang=js&"
export * from "./FavoriteLocationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports